webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(234);
	
	__webpack_require__(235);
	
	__webpack_require__(222);
	
	__webpack_require__(223);
	
	var _en = __webpack_require__(208);
	
	var _en2 = _interopRequireDefault(_en);
	
	__webpack_require__(221);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(284);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _elementUi = __webpack_require__(205);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _vueRouter = __webpack_require__(302);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routerConfig = __webpack_require__(145);
	
	var _routerConfig2 = _interopRequireDefault(_routerConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(219);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	
	var router = new _vueRouter2.default({
	  routes: _routerConfig2.default,
	  mode: 'history',
	  saveScrollPosition: true
	});
	
	new _vue2.default({
	  router: router,
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ElementMessageMixin = exports.setClipboardText = exports.formatDate = exports.clone = exports.compact = exports.browser = undefined;
	
	var _assign = __webpack_require__(71);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(154);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function compact(data) {
	  if (!data) return {};
	  for (var key in data) {
	    var v = data[key];
	    if (v === null || typeof v === 'undefined' || v === '') delete data[key];
	  }
	  return data;
	}
	
	function formatDate(date) {
	  var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  if (typeof date === 'string') date = new Date(date);
	  var Y = date.getFullYear();
	  var M = ('0' + date.getMonth() + 1).slice(-2);
	  var D = ('0' + date.getDate()).slice(-2);
	  var h = ('0' + date.getHours()).slice(-2);
	  var m = ('0' + date.getMinutes()).slice(-2);
	  var s = ('0' + date.getSeconds()).slice(-2);
	  var part1 = Y + '-' + M + '-' + D;
	  var part2 = h + ':' + m + ':' + s;
	  return withTime ? part1 + ' ' + part2 : part1;
	}
	
	function clone(obj) {
	  return JSON.parse((0, _stringify2.default)(obj));
	}
	
	var ElementMessageMixin = {
	  methods: {
	    $success: function $success(msg) {
	      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.$message((0, _assign2.default)({
	        duration: 2000,
	        message: msg,
	        type: 'success'
	      }, opt));
	    },
	    $warning: function $warning(msg) {
	      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.$message((0, _assign2.default)({
	        duration: 2000,
	        message: msg,
	        type: 'warning'
	      }, opt));
	    },
	    $error: function $error(msg) {
	      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.$message((0, _assign2.default)({
	        duration: 2000,
	        message: msg,
	        type: 'error'
	      }, opt));
	    },
	    $ask: function $ask(msg) {
	      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
	      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      opts.type = type;
	      return this.$confirm(msg, opts);
	    }
	  }
	};
	
	function setClipboardText(text) {
	  var input = document.createElement('textarea');
	  document.body.appendChild(input);
	
	  input.style.position = 'absolute';
	  input.style.top = 0;
	  input.style.left = 0;
	  input.style.zIndex = -1;
	  input.value = text;
	  input.focus();
	  input.select();
	  var ret = document.execCommand('Copy');
	  input.remove();
	  return ret;
	}
	
	function uaMatch(ua) {
	  if (ua === undefined) {
	    ua = window.navigator.userAgent;
	  }
	  ua = ua.toLowerCase();
	
	  var match = /(edge)\/([\w.]+)/.exec(ua) || /(opr)[/]([\w.]+)/.exec(ua) || /(chrome)[ /]([\w.]+)/.exec(ua) || /(iemobile)[/]([\w.]+)/.exec(ua) || /(version)(applewebkit)[ /]([\w.]+).*(safari)[ /]([\w.]+)/.exec(ua) || /(webkit)[ /]([\w.]+).*(version)[ /]([\w.]+).*(safari)[ /]([\w.]+)/.exec(ua) || /(webkit)[ /]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf('trident') >= 0 && /(rv)(?::|)([\w.]+)/.exec(ua) || ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
	
	  var platformMatch = /(ipad)/.exec(ua) || /(ipod)/.exec(ua) || /(windows phone)/.exec(ua) || /(iphone)/.exec(ua) || /(kindle)/.exec(ua) || /(silk)/.exec(ua) || /(android)/.exec(ua) || /(win)/.exec(ua) || /(mac)/.exec(ua) || /(linux)/.exec(ua) || /(cros)/.exec(ua) || /(playbook)/.exec(ua) || /(bb)/.exec(ua) || /(blackberry)/.exec(ua) || [];
	
	  var browser = {};
	  var matched = {
	    browser: match[5] || match[3] || match[1] || '',
	    version: match[2] || match[4] || '0',
	    versionNumber: match[4] || match[2] || '0',
	    platform: platformMatch[0] || ''
	  };
	
	  if (matched.browser) {
	    browser[matched.browser] = true;
	    browser.version = matched.version;
	    browser.versionNumber = parseInt(matched.versionNumber, 10);
	  }
	
	  if (matched.platform) {
	    browser[matched.platform] = true;
	  }
	
	  if (browser.android || browser.bb || browser.blackberry || browser.ipad || browser.iphone || browser.ipod || browser.kindle || browser.playbook || browser.silk || browser['windows phone']) {
	    browser.mobile = true;
	  }
	
	  if (browser.cros || browser.mac || browser.linux || browser.win) {
	    browser.desktop = true;
	  }
	
	  if (browser.chrome || browser.opr || browser.safari) {
	    browser.webkit = true;
	  }
	
	  if (browser.rv || browser.iemobile) {
	    var ie = 'msie';
	
	    matched.browser = ie;
	    browser[ie] = true;
	  }
	
	  if (browser.edge) {
	    delete browser.edge;
	    var msedge = 'msedge';
	
	    matched.browser = msedge;
	    browser[msedge] = true;
	  }
	
	  if (browser.safari && browser.blackberry) {
	    var blackberry = 'blackberry';
	
	    matched.browser = blackberry;
	    browser[blackberry] = true;
	  }
	
	  if (browser.safari && browser.playbook) {
	    var playbook = 'playbook';
	
	    matched.browser = playbook;
	    browser[playbook] = true;
	  }
	
	  if (browser.bb) {
	    var bb = 'blackberry';
	
	    matched.browser = bb;
	    browser[bb] = true;
	  }
	
	  if (browser.opr) {
	    var opera = 'opera';
	
	    matched.browser = opera;
	    browser[opera] = true;
	  }
	
	  if (browser.safari && browser.android) {
	    var android = 'android';
	
	    matched.browser = android;
	    browser[android] = true;
	  }
	
	  if (browser.safari && browser.kindle) {
	    var kindle = 'kindle';
	
	    matched.browser = kindle;
	    browser[kindle] = true;
	  }
	
	  if (browser.safari && browser.silk) {
	    var silk = 'silk';
	
	    matched.browser = silk;
	    browser[silk] = true;
	  }
	
	  browser.name = matched.browser;
	  browser.platform = matched.platform;
	  return browser;
	}
	
	var browser = uaMatch(window.navigator.userAgent);
	
	exports.browser = browser;
	exports.compact = compact;
	exports.clone = clone;
	exports.formatDate = formatDate;
	exports.setClipboardText = setClipboardText;
	exports.ElementMessageMixin = ElementMessageMixin;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(39);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _utils = __webpack_require__(17);
	
	var _cookiesJs = __webpack_require__(74);
	
	var _cookiesJs2 = _interopRequireDefault(_cookiesJs);
	
	var _get = __webpack_require__(273);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiurl = function apiurl(path) {
	  return '/referralrest/' + path;
	};
	var ts = function ts(path) {
	  return path + '?t=' + new Date().getTime();
	};
	var TOKEN_NAME = 'PARTNER_TOKEN';
	var DOMAIN = '.vipkid.com.cn';
	if (window.location.hostname.indexOf('vipkid-qa.com.cn') > -1) DOMAIN = '.vipkid-qa.com.cn';
	
	var api = {
	  search: function search(params) {
	    return _axios2.default.post(apiurl('teacher/findListByPartner'), (0, _utils.compact)((0, _utils.clone)(params)));
	  },
	  verifycode: function verifycode() {
	    return _axios2.default.get(ts(apiurl('user/verifycode')));
	  },
	  getUserInfo: function getUserInfo() {
	    var promise = _axios2.default.get(ts(apiurl('user/auth')));
	    promise.then(function (e) {
	      if (e.data.data && e.data.data.expires) {
	        var day = e.data.data.expires;
	        e.data.data.expiresDay = day + ' day' + (day > 1 ? 's' : '');
	      }
	    });
	    return promise;
	  },
	  login: function login(param) {
	    return _axios2.default.post(apiurl('user/login'), param).then(function (e) {
	      var token = (0, _get2.default)(e, 'data.data.token');
	      _cookiesJs2.default.set(TOKEN_NAME, token, {
	        domain: DOMAIN,
	        expires: 12 * 60 * 60
	      });
	      return e;
	    });
	  },
	  isLogined: function isLogined() {
	    return !!_cookiesJs2.default.get(TOKEN_NAME);
	  },
	  logout: function logout() {
	    return _axios2.default.put(apiurl('common/logout')).catch(function (_) {
	      return _;
	    });
	  }
	};
	
	exports.default = api;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(155);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _originalAxios = __webpack_require__(125);
	
	var _originalAxios2 = _interopRequireDefault(_originalAxios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookies = __webpack_require__(74);
	var LoginPathname = '/login';
	
	_originalAxios2.default.interceptors.request.use(function (config) {
	  var cookieAuth = cookies.get('PARTNER_TOKEN') || '';
	  var headers = config.headers;
	
	  if (!headers.Authorization && cookieAuth) {
	    headers['Authorization'] = cookieAuth;
	  }
	  return config;
	});
	
	_originalAxios2.default.interceptors.response.use(function (resp) {
	  return resp;
	}, function (err) {
	  if (err.response.status === 401 && window.location.pathname !== LoginPathname) {
	    window.location.href = LoginPathname;
	  }
	  return _promise2.default.reject(err);
	});
	
	exports.default = _originalAxios2.default;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axios = __webpack_require__(39);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _utils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiurl = function apiurl(path) {
	  return '/referralrest/' + path;
	};
	var api = {
	  essential: function essential(params) {
	    return _axios2.default.post(apiurl('user/referralPartner'), (0, _utils.compact)((0, _utils.clone)(params)));
	  },
	  getVerifycode: function getVerifycode() {
	    return _axios2.default.get('/referralrest/user/verifycode?t=' + new Date().getTime());
	  }
	};
	
	exports.default = api;

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(289);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _referral = __webpack_require__(292);
	
	var _referral2 = _interopRequireDefault(_referral);
	
	var _information = __webpack_require__(288);
	
	var _information2 = _interopRequireDefault(_information);
	
	var _protocol = __webpack_require__(290);
	
	var _protocol2 = _interopRequireDefault(_protocol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/login', component: _login2.default }, { path: '/referral', component: _referral2.default }, { path: '/information', component: _information2.default }, { path: '/protocol', component: _protocol2.default }, { path: '/', redirect: { path: '/referral' } }, { path: '/*', redirect: { path: '/referral' } }];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _referralApi = __webpack_require__(26);
	
	var _referralApi2 = _interopRequireDefault(_referralApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      user: {
	        contractStartTime: '',
	        contractEndTime: '',
	        username: '',
	        email: '',
	        status: ''
	      }
	    };
	  },
	  mounted: function mounted() {
	    window.$app = this;
	
	    if (this.$route.path === '/information') return;
	
	    if (this.$route.path === '/protocol') return;
	
	    if (!_referralApi2.default.isLogined()) {
	      this.$router.push({ path: 'login' });
	      return;
	    }
	
	    this.getUserInfo();
	  },
	
	  methods: {
	    isUserInfoEmpty: function isUserInfoEmpty() {
	      if (!this.user) return true;
	      var u = this.user;
	      return !u.username && !u.email && !u.status && !u.contractStartTime && !u.contractEndTime;
	    },
	    setUserInfo: function setUserInfo(user) {
	      this.user = user;
	    },
	    getUserInfo: function getUserInfo() {
	      var _this = this;
	
	      return _referralApi2.default.getUserInfo().then(function (e) {
	        if (e.data.success) {
	          _this.user = e.data.data;
	        } else {
	          _this.$router.push({ path: 'referral' });
	        }
	      }).catch(function (_) {
	        return _;
	      });
	    }
	  }
	};

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var _referralApi = __webpack_require__(26);
	
	var _referralApi2 = _interopRequireDefault(_referralApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_utils.ElementMessageMixin],
	  name: 'navbar',
	  props: ['user'],
	  data: function data() {
	    return {
	      imgVipkidLogo: __webpack_require__(280),
	      isShowUserInfoPopover: false
	    };
	  },
	
	  methods: {
	    onCopyReferralLink: function onCopyReferralLink() {
	      var _this = this;
	
	      console.log(this.user);
	      var id = this.user.id;
	      var url = 'https://www.vipkid.com/teach?partnerId=' + id;
	      var showDialog = function showDialog() {
	        _this.$prompt('Please copy it manually.', 'Infomation', {
	          inputPlaceholder: url,
	          confirmButtonText: 'OK',
	          showCancelButton: false
	        }).catch(function (_) {
	          return _;
	        });
	        setTimeout(function (_) {
	          var input = document.querySelector('.el-message-box input');
	          input.value = url;
	          input.placeholder = '';
	          input.focus();
	          input.select();
	        }, 300);
	      };
	      if (_utils.browser.msie && _utils.browser.version <= '11.0') {
	        showDialog();
	      } else if ((0, _utils.setClipboardText)(url)) {
	        this.$success('Copied Successfully!');
	      } else {
	        showDialog();
	      }
	    },
	    onLogout: function onLogout() {
	      var _this2 = this;
	
	      _referralApi2.default.logout().then(function () {
	        _this2.$router.push({ path: '/login' });
	      });
	    }
	  }
	};

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(72);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(153);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _utils = __webpack_require__(17);
	
	var _information = __webpack_require__(144);
	
	var _information2 = _interopRequireDefault(_information);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_utils.ElementMessageMixin],
	  data: function data() {
	    return {
	      success: false,
	      showError: false,
	      imageCodeImgSrc: '',
	      from: {
	        firstName: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        lastName: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        contactEmail: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        phoneNumber: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        companyName: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        companyWebsite: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        companyType: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        potentialTeacherNumber: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        businessDescription: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        channels: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        isAgree: {
	          value: false,
	          isRequired: true,
	          isTrue: true,
	          isActive: false
	        },
	        imageCode: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: false,
	          imageCodeError: true
	        },
	        key: {
	          value: '',
	          isRequired: true,
	          isTrue: true,
	          isActive: true
	        }
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.getVerifyCode();
	  },
	
	  methods: {
	    getVerifyCode: function getVerifyCode() {
	      var _this = this;
	
	      _information2.default.getVerifycode().then(function (res) {
	        _this.imageCodeImgSrc = res.data.data.value;
	        _this.from.key.value = res.data.data.key;
	      }).catch(function (e) {
	        console.log(e);
	      });
	    },
	    changeActive: function changeActive(item) {
	      if (Object.prototype.toString.call(item.value) === '[object String]') item.value = item.value.trim();
	      item.isActive = true;
	    },
	    focusImageCode: function focusImageCode() {
	      this.from.imageCode.imageCodeError = true;
	    },
	    validateFrom: function validateFrom() {
	      var _this2 = this;
	
	      this.showError = true;
	      var params = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.from)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var name = _step.value;
	
	          params[name] = this.from[name].value;
	          if (!this.from[name].isTrue) return;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      delete params.isAgree;
	
	      var defaultErrorMsg = 'Fail to get data from server, please try later.';
	      _information2.default.essential(params).then(function (res) {
	        var data = res && res.data || {};
	        if (data.code + '' === '200') {
	          _this2.success = true;
	        } else {
	          _this2.$error(data.message || defaultErrorMsg);
	
	          if (data.message === 'Verification code error.') {
	            _this2.imageCodeErrorHandle();
	          }
	        }
	      }).catch(function (e) {
	        _this2.imageCodeErrorHandle();
	      });
	    },
	    imageCodeErrorHandle: function imageCodeErrorHandle() {
	      this.from.imageCode.imageCodeError = false;
	      this.from.imageCode.isTrue = false;
	    }
	  },
	  filters: {
	    nameFilter: function nameFilter(val, item) {
	      if (val === '' && item.isRequired) {
	        item.isTrue = false;
	        return 'Please don\'t leave this blank!';
	      }
	
	      if (val.indexOf('..') > -1 || val.indexOf('\'\'') > -1 || val.indexOf('··') > -1) {
	        item.isTrue = false;
	        return 'Only accept English characters.';
	      }
	
	      if (val.length !== 0 && (val.lastIndexOf('\'') === val.length - 1 || val.lastIndexOf('.') === val.length - 1 || val.lastIndexOf('·') === val.length - 1)) {
	        item.isTrue = false;
	        return 'Only accept English characters.';
	      }
	
	      if (val.indexOf('.') === 0 || val.indexOf('·') === 0) {
	        item.isTrue = false;
	        return 'Only accept English characters.';
	      }
	
	      var newStr = val.replace(/\./g, 'a').replace(/'/g, 'a').replace(/·/g, 'a');
	      if (!/^([A-Za-z]+\s?)*[A-Za-z]$/.test(newStr) && newStr) {
	        item.isTrue = false;
	        return 'Only accept English characters.';
	      }
	      item.isTrue = true;
	    },
	    emailFilter: function emailFilter(val, item) {
	      if (val === '' && item.isRequired) {
	        item.isTrue = false;
	        return 'Please don\'t leave this blank!';
	      }
	      if (!/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(val.trim())) {
	        item.isTrue = false;
	        return 'Email format incorrect!';
	      }
	      item.isTrue = true;
	    },
	    numFilter: function numFilter(val, item) {
	      if (val === '' && item.isRequired) {
	        item.isTrue = false;
	        return 'Please don\'t leave this blank!';
	      }
	      if (!/^[0-9\s]*$/.test(item.value)) {
	        item.isTrue = false;
	        return 'Your phone number can only be numbers.';
	      }
	      item.isTrue = true;
	    },
	    charactersFilter: function charactersFilter(val, item) {
	      if (val === '' && item.isRequired) {
	        item.isTrue = false;
	        return 'Please don\'t leave this blank!';
	      }
	      item.isTrue = true;
	    },
	    imageCodeFilter: function imageCodeFilter(val, item) {
	      var errorInfo = 'Your verification code is incorrect.\n';
	      if (val === '' && item.isRequired) {
	        item.isTrue = false;
	        return errorInfo;
	      }
	      if (val !== '' && !item.imageCodeError) {
	        item.isTrue = false;
	        item.imageCodeError = false;
	        return errorInfo;
	      }
	      item.isTrue = true;
	      item.imageCodeError = true;
	    },
	    allFilter: function allFilter(val, item) {
	      if (val === '' && item.isRequired) {
	        item.isTrue = false;
	        return 'Please don\'t leave this blank!';
	      }
	      item.isTrue = true;
	    },
	    agreeFilter: function agreeFilter(val, item) {
	      if (item.isRequired && !val) {
	        item.isTrue = false;
	        return 'Please don\'t leave this blank!';
	      }
	      item.isTrue = true;
	    }
	  },
	  watch: {}
	};

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(17);
	
	var _referralApi = __webpack_require__(26);
	
	var _referralApi2 = _interopRequireDefault(_referralApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorMsg = {
	  'USERNAMENULL': 'Please input your user name.',
	  'PASSWORDNULL': 'Please input your password.',
	  'SIGNUPWRONG': 'Password or user name is incorrect!',
	  'VERIFICATIONEMPTY': 'Please enter the verification code.',
	  'VERIFICATIONWRONG': 'Your verification code is incorrect.',
	  'NOTLOGIN': 'Please sign in'
	};
	
	exports.default = {
	  mixins: [_utils.ElementMessageMixin],
	  data: function data() {
	    return {
	      username: '',
	      password: '',
	      imageCode: '',
	      imageKey: '',
	      signErrorShow: false,
	      signErrorMsg: '',
	      usernameErrorShow: false,
	      passwordErrorShow: false,
	      verificationShow: false,
	      verificationErrorShow: false,
	      expired: false,
	
	      verifycodeSrc: '',
	      status: 'expired'
	    };
	  },
	  mounted: function mounted() {
	    window.$loginpage = this;
	  },
	
	  methods: {
	    sign: function sign() {
	      var _this = this;
	
	      this.verificationErrorShow = false;
	      if (!this.validate()) {
	        this.signErrorShow = true;
	        return;
	      } else {
	        this.signErrorShow = false;
	        this.usernameErrorShow = false;
	        this.passwordErrorShow = false;
	      }
	      var param = {
	        username: this.username,
	        password: this.password,
	        imageCode: this.imageCode,
	        key: this.imageKey
	      };
	      _referralApi2.default.login(param).then(function (response) {
	        if (response.data.success) {
	          _referralApi2.default.getUserInfo().then(function (e) {
	            if (e.data.success) {
	              _this.$parent.setUserInfo(e.data.data);
	              _this.$router.push({ path: 'referral' });
	            } else {
	              _this.$error('Get user info failed, please try later.');
	            }
	          }).catch(function (e) {
	            _this.fail(e.response);
	          });
	        } else {
	          _this.fail(response);
	        }
	      }).catch(function (e) {
	        _this.fail(e.response);
	      });
	    },
	    fail: function fail(error) {
	      var code = error.data.code;
	      if (code === '-2' || code === '-3') {
	        this.getVerifyCode();
	        this.signErrorShow = true;
	        if (code === '-2') {
	          this.signErrorMsg = errorMsg.VERIFICATIONEMPTY;
	        } else {
	          this.signErrorMsg = errorMsg.VERIFICATIONWRONG;
	        }
	        return;
	      } else if (code === '-7' || code === '-6') {
	        if (code === '-6') this.status = 'locked';
	        this.showExpiredDialog();
	        return;
	      } else if (code === '-12') {
	        this.signErrorMsg = errorMsg.NOTLOGIN;
	      }
	      this.signErrorShow = true;
	      this.signErrorMsg = errorMsg.SIGNUPWRONG;
	    },
	    validate: function validate() {
	      if (this.username === '') {
	        this.signErrorMsg = errorMsg.USERNAMENULL;
	        this.usernameErrorShow = true;
	        return false;
	      }
	      if (this.password === '') {
	        this.signErrorMsg = errorMsg.PASSWORDNULL;
	        this.usernameErrorShow = false;
	        this.passwordErrorShow = true;
	        return false;
	      }
	      return true;
	    },
	    getVerifyCode: function getVerifyCode() {
	      var _this2 = this;
	
	      _referralApi2.default.verifycode().then(function (respones) {
	        _this2.imageCode = '';
	        _this2.verifycodeSrc = respones.data.data.value;
	        _this2.imageKey = respones.data.data.key;
	        if (!_this2.verificationShow) _this2.verificationShow = true;
	        _this2.verificationErrorShow = true;
	      });
	    },
	    showExpiredDialog: function showExpiredDialog() {
	      this.expired = true;
	    },
	    closeExpiredDialog: function closeExpiredDialog() {
	      this.expired = false;
	    }
	  },
	  watch: {
	    verificationShow: function verificationShow() {
	      var _this3 = this;
	
	      if (this.verificationShow) {
	        setTimeout(function () {
	          _this3.$refs.code.focus();
	        }, 200);
	      }
	    }
	  }
	};

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(286);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _protocol = __webpack_require__(287);
	
	var _protocol2 = _interopRequireDefault(_protocol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ProtocolHeader: _header2.default,
	    ProtocolContent: _protocol2.default
	  }
	};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(72);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _axios = __webpack_require__(39);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _select = __webpack_require__(93);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Statuses = {
	  '': 'All',
	  BASIC_INFO: 'Basic info',
	  INTERVIEW: 'Interview',
	  CERTIFICATE: 'Certification',
	  CONTRACT_INFO: 'Contract Info'
	};
	
	var AuditResults = {
	  '': {
	    '': 'All',
	    PASS: 'Pass',
	    FAIL: 'Fail',
	    PENDING: 'Pending',
	    START: 'Start',
	    REAPPLY: 'Reapply'
	  },
	  BASIC_INFO: {
	    '': 'All',
	    PASS: 'Pass',
	    FAIL: 'Fail',
	    PENDING: 'Pending'
	  },
	  INTERVIEW: {
	    '': 'All',
	    PASS: 'Pass',
	    FAIL: 'Fail',
	    REAPPLY: 'Reapply',
	    PENDING: 'Pending',
	    START: 'Start'
	  },
	  CERTIFICATE: {
	    '': 'All',
	    PASS: 'Pass',
	    PENDING: 'Pending'
	  },
	  CONTRACT_INFO: {
	    '': 'All',
	    PASS: 'Pass',
	    REAPPLY: 'Reapply',
	    PENDING: 'Pending',
	    START: 'Start'
	  }
	};
	
	exports.default = {
	  components: {
	    ElSelect: _select2.default
	  },
	  data: function data() {
	    return {
	      statuses: Statuses,
	      auditResults: AuditResults,
	      query: makeEmptyQuery(),
	      loading: false,
	      tempValue: '',
	      options: []
	    };
	  },
	
	  methods: {
	    setStatus: function setStatus(val) {
	      this.query.status = val;
	
	      if (typeof this.auditResults[this.query.status][this.query.result] === 'undefined') {
	        this.query.result = '';
	      }
	      this.queryChanged();
	    },
	    setAuditResult: function setAuditResult(val) {
	      this.query.result = val;
	      this.queryChanged();
	    },
	    resetFilter: function resetFilter() {
	      this.query = makeEmptyQuery();
	      this.queryChanged();
	    },
	    queryChanged: function queryChanged(e) {
	      this.$emit('querychanged', this.query);
	    },
	    getEmptyTdNumber: function getEmptyTdNumber(a) {
	      return 6 - (0, _keys2.default)(a).length + 1;
	    },
	    setLabel: function setLabel(item) {
	      return item.fullName + ' (' + item.email + ')';
	    },
	    onChange: function onChange(val) {
	      this.tempValue = val;
	      this.queryChanged();
	    },
	    onRemoteMethod: function onRemoteMethod(val) {
	      var _this = this;
	
	      var query = val.trim();
	      var candidateId = this.query.account;
	      if (!val || query.length < 3 || candidateId && candidateId === this.tempValue) return;
	      setTimeout(function () {
	        _this.loading = true;
	        _this.getTeacherData(query);
	      }, 500);
	    },
	    getTeacherData: function getTeacherData(query) {
	      var _this2 = this;
	
	      _axios2.default.get('/referralrest/common/teachers', {
	        params: {
	          accountType: 'NORMAL',
	          account: query
	        }
	      }).then(function (res) {
	        if (res.data.success) {
	          _this2.loading = false;
	          var data = res.data.data;
	
	          _this2.options = data;
	        }
	      }).catch(function (e) {
	        _this2.loading = false;
	      });
	    }
	  }
	};
	
	
	function makeEmptyQuery() {
	  return {
	    dataType: '',
	    startTime: '',
	    endTime: '',
	    account: '',
	    status: '',
	    result: ''
	  };
	}

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navbar = __webpack_require__(285);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _queryBar = __webpack_require__(291);
	
	var _queryBar2 = _interopRequireDefault(_queryBar);
	
	var _referralApi = __webpack_require__(26);
	
	var _referralApi2 = _interopRequireDefault(_referralApi);
	
	var _utils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_utils.ElementMessageMixin],
	  props: ['user'],
	  data: function data() {
	    return {
	      tableData: [],
	      total: 0,
	      currentPage: 1,
	      pageSize: 20,
	      searchParam: {},
	      loading: false,
	      isShowContractDataPopover: false
	    };
	  },
	
	  computed: {
	    tableStatusText: function tableStatusText() {
	      if (this.loading) {
	        return 'Loading...';
	      } else if (this.total === 0) {
	        return 'Oops! Couldn’t find any records';
	      } else {
	        return '';
	      }
	    }
	  },
	  mounted: function mounted() {
	    window.$referralpage = this;
	    if (this.user.email) {
	      this.search();
	      this.showContractDataPopover();
	    }
	  },
	
	  methods: {
	    reset: function reset(data) {
	      this.tableData = data || [];
	      this.loading = false;
	    },
	    search: function search(params) {
	      var _this = this;
	
	      if (params) {
	        this.searchParam = params;
	      } else {
	        params = this.searchParam;
	      }
	      params.page = this.currentPage;
	
	      if (params.dataType) {
	        if (!params.startTime) {
	          this.$warning('Please set start date');
	          return;
	        }
	        if (!params.endTime) {
	          this.$warning('Please set end date');
	          return;
	        }
	
	        if (params.startTime > params.endTime) {
	          this.$warning('End date must after Start date');
	          return;
	        }
	      }
	
	      var errorMsg = 'Fail to get data from server, please try later.';
	      this.loading = true;
	      this.tableData.length = 0;
	      _referralApi2.default.search(params).then(function (e) {
	        if (e.data.success) {
	          if (e.data.data.list && e.data.data.list.length > 0) {
	            e.data.data.list.forEach(function (it) {
	              it.mobile2 = it.codes + ' ' + it.mobile;
	            });
	          }
	          _this.reset(e.data.data.list);
	          _this.total = e.data.data.count;
	        } else {
	          _this.reset();
	          _this.$error(errorMsg);
	        }
	      }).catch(function (e) {
	        console.error(e);
	        _this.reset();
	        _this.$error(errorMsg);
	      });
	    },
	    queryChanged: function queryChanged(query) {
	      this.currentPage = 1;
	      this.searchParam = query;
	      this.search();
	    },
	    onCurrentPageChange: function onCurrentPageChange(page) {
	      this.currentPage = page;
	      this.search();
	    },
	    closeContractDataPopover: function closeContractDataPopover() {
	      this.isShowContractDataPopover = false;
	    },
	    toggleContractDataPopover: function toggleContractDataPopover() {
	      this.isShowContractDataPopover = !this.isShowContractDataPopover;
	    },
	    showContractDataPopover: function showContractDataPopover() {
	      var _this2 = this;
	
	      if (this.user.expires) {
	        setTimeout(function (_) {
	          _this2.isShowContractDataPopover = true;
	        }, 1000);
	      }
	    }
	  },
	  watch: {
	    'user.email': function userEmail() {
	      if (this.user.email) {
	        this.search();
	        this.showContractDataPopover();
	      }
	    }
	  },
	  components: {
	    'query-bar': _queryBar2.default,
	    'navbar': _navbar2.default
	  }
	};

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/success-tips.055aaa6.png";

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(228)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(146),
	  /* template */
	  __webpack_require__(296),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(225)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(147),
	  /* template */
	  __webpack_require__(294),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(224)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(293),
	  /* scopeId */
	  "data-v-15283501",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(229)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(297),
	  /* scopeId */
	  "data-v-3cf0bc8c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(230)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(148),
	  /* template */
	  __webpack_require__(299),
	  /* scopeId */
	  "data-v-73bd7b58",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(231)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(149),
	  /* template */
	  __webpack_require__(300),
	  /* scopeId */
	  "data-v-a52d955c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(150),
	  /* template */
	  __webpack_require__(298),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(226)
	__webpack_require__(227)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(151),
	  /* template */
	  __webpack_require__(295),
	  /* scopeId */
	  "data-v-2a322946",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(232)
	__webpack_require__(233)
	
	var Component = __webpack_require__(9)(
	  /* script */
	  __webpack_require__(152),
	  /* template */
	  __webpack_require__(301),
	  /* scopeId */
	  "data-v-d10faac4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('p', {
	    staticClass: "line"
	  }), _vm._v(" "), _c('a', {
	    staticClass: "logo",
	    attrs: {
	      "href": "/mkt/affiliate-program"
	    }
	  })])
	}]}

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "navbar"
	  }, [_c('el-popover', {
	    ref: "popoveruser",
	    staticClass: "userinfo",
	    attrs: {
	      "placement": "bottom",
	      "trigger": "click"
	    },
	    model: {
	      value: (_vm.isShowUserInfoPopover),
	      callback: function($$v) {
	        _vm.isShowUserInfoPopover = $$v
	      },
	      expression: "isShowUserInfoPopover"
	    }
	  }, [_c('div', {
	    staticClass: "referral-userinfo-popover"
	  }, [_c('label', {
	    attrs: {
	      "for": "user-name"
	    }
	  }, [_vm._v("User name"), _c('span', {
	    attrs: {
	      "id": "user-name"
	    }
	  }, [_vm._v(_vm._s(_vm.user.username))])]), _c('label', {
	    attrs: {
	      "for": "user-email"
	    }
	  }, [_vm._v("Email"), _c('span', {
	    attrs: {
	      "id": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.user.email))])]), _c('label', {
	    attrs: {
	      "for": "user-status"
	    }
	  }, [_vm._v("Status"), _c('span', {
	    attrs: {
	      "id": "user-status"
	    }
	  }, [_vm._v(_vm._s(_vm.user.status))])])])]), _c('el-menu', {
	    attrs: {
	      "default-active": "1",
	      "mode": "horizontal"
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    staticStyle: {
	      "width": "110px",
	      "height": "32px"
	    },
	    attrs: {
	      "src": _vm.imgVipkidLogo
	    }
	  }), _c('el-menu-item', {
	    staticStyle: {
	      "padding-right": "0"
	    },
	    attrs: {
	      "index": "3"
	    }
	  }, [_c('b', {
	    on: {
	      "click": _vm.onLogout
	    }
	  }, [_vm._v("Logout")])]), _c('el-menu-item', {
	    staticClass: "arrow",
	    attrs: {
	      "index": "2"
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popoveruser",
	      arg: "popoveruser"
	    }]
	  }, [_c('span', {
	    staticStyle: {
	      "margin-right": "5px"
	    }
	  }, [_vm._v("My account")]), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.isShowUserInfoPopover),
	      expression: "!isShowUserInfoPopover"
	    }],
	    staticClass: "el-icon-arrow-down"
	  }), _c('i', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShowUserInfoPopover),
	      expression: "isShowUserInfoPopover"
	    }],
	    staticClass: "el-icon-arrow-up"
	  })])]), _c('el-menu-item', {
	    attrs: {
	      "index": "1"
	    }
	  }, [_c('el-button', {
	    staticClass: "copy-link",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.onCopyReferralLink($event)
	      }
	    }
	  }, [_vm._v("Copy Referral Link\n"), _c('svg', {
	    staticClass: "icon-link",
	    attrs: {
	      "width": "20",
	      "height": "20",
	      "viewBox": "0 0 20 20",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "fill-rule": "evenodd"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M6.248 8.934l-2.423 2.422a3.435 3.435 0 0 0 0 4.854 3.434 3.434 0 0 0 4.854 0l2.986-2.986a3.435 3.435 0 0 0-.208-5.044l-1.41 1.373a1.653 1.653 0 0 1 .241 2.532L7.54 14.834a1.653 1.653 0 0 1-2.337-2.337l1.433-1.434a1.608 1.608 0 0 1-.208-.313l-.038-.074c-.262-.51-.298-1.158-.14-1.742z"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M13.707 11.182L16.12 8.77a3.435 3.435 0 0 0 0-4.854 3.434 3.434 0 0 0-4.853 0L8.28 6.902a3.435 3.435 0 0 0 .5 5.266l1.427-1.428a1.653 1.653 0 0 1-.55-2.699l2.749-2.749a1.653 1.653 0 0 1 2.337 2.337L13.31 9.064l.307.824c.144.386.167.846.09 1.295z"
	    }
	  })])])])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "query-bar"
	  }, [_c('div', {
	    staticClass: "query-fields"
	  }, [_c('el-row', [_c('el-select', {
	    staticStyle: {
	      "width": "208px"
	    },
	    on: {
	      "change": _vm.queryChanged
	    },
	    model: {
	      value: (_vm.query.dataType),
	      callback: function($$v) {
	        _vm.$set(_vm.query, "dataType", $$v)
	      },
	      expression: "query.dataType"
	    }
	  }, [_c('el-option', {
	    attrs: {
	      "label": "- Search type -",
	      "value": ""
	    }
	  }), _c('el-option', {
	    attrs: {
	      "label": "Become Regular Teacher",
	      "value": 2
	    }
	  }), _c('el-option', {
	    attrs: {
	      "label": "Teach 1st Class",
	      "value": 3
	    }
	  }), _c('el-option', {
	    attrs: {
	      "label": "Apply Time",
	      "value": 1
	    }
	  })], 1), _c('span', {
	    staticClass: "separator"
	  }), _c('el-date-picker', {
	    staticClass: "start-date",
	    attrs: {
	      "type": "date",
	      "placeholder": "Start Date"
	    },
	    model: {
	      value: (_vm.query.startTime),
	      callback: function($$v) {
	        _vm.$set(_vm.query, "startTime", $$v)
	      },
	      expression: "query.startTime"
	    }
	  }), _c('span', {
	    staticClass: "separator"
	  }, [_vm._v("to")]), _c('el-date-picker', {
	    staticClass: "end-date",
	    attrs: {
	      "type": "date",
	      "placeholder": "End Date"
	    },
	    model: {
	      value: (_vm.query.endTime),
	      callback: function($$v) {
	        _vm.$set(_vm.query, "endTime", $$v)
	      },
	      expression: "query.endTime"
	    }
	  }), _c('span', {
	    staticClass: "separator"
	  }), _c('el-input', {
	    staticStyle: {
	      "width": "20em"
	    },
	    attrs: {
	      "placeholder": "ID / Name / Email"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.queryChanged($event)
	      }
	    },
	    model: {
	      value: (_vm.query.account),
	      callback: function($$v) {
	        _vm.$set(_vm.query, "account", $$v)
	      },
	      expression: "query.account"
	    }
	  }), _c('span', {
	    staticClass: "separator"
	  }), _c('el-button', {
	    staticClass: "search-btn",
	    attrs: {
	      "icon": "search"
	    },
	    on: {
	      "click": _vm.queryChanged
	    }
	  }, [_vm._v("Search")])], 1)], 1), _c('table', {
	    staticClass: "query-status-result",
	    staticStyle: {
	      "table-layout": "fixed"
	    },
	    attrs: {
	      "width": "100%"
	    }
	  }, [_c('tr', {
	    staticStyle: {
	      "height": "64px"
	    }
	  }, [_c('td', [_vm._v("Status")]), _vm._l((_vm.statuses), function(text, key) {
	    return _c('td', [_c('a', {
	      staticClass: "status",
	      class: {
	        selected: _vm.query.status === key
	      },
	      attrs: {
	        "href": "javascript:;"
	      },
	      domProps: {
	        "textContent": _vm._s(text)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setStatus(key)
	        }
	      }
	    })])
	  }), _c('td'), _c('td')], 2), _c('tr', {
	    staticStyle: {
	      "height": "64px"
	    }
	  }, [_c('td', [_vm._v("Result")]), _vm._l((_vm.auditResults[_vm.query.status]), function(text, key) {
	    return _c('td', [_c('a', {
	      staticClass: "status",
	      class: {
	        selected: _vm.query.result === key
	      },
	      attrs: {
	        "href": "javascript:;"
	      },
	      domProps: {
	        "textContent": _vm._s(text)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setAuditResult(key)
	        }
	      }
	    })])
	  }), _vm._l((_vm.getEmptyTdNumber(_vm.auditResults[_vm.query.status])), function(a) {
	    return _c('td')
	  })], 2)]), _c('el-button', {
	    staticClass: "reset-btn",
	    on: {
	      "click": _vm.resetFilter
	    }
	  }, [_vm._v("Reset Filter\n"), _c('svg', {
	    staticClass: "refresh",
	    attrs: {
	      "width": "26",
	      "height": "17",
	      "viewBox": "0 0 26 17",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('g', {
	    attrs: {
	      "fill-rule": "evenodd"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M4.461 13.545L8.1 9.822H.823zM17.717 3.965l3.638 3.723H14.08z"
	    }
	  }), _c('path', {
	    attrs: {
	      "d": "M17.442 4.352A7.615 7.615 0 0 1 6.937 14.857l1.235-1.236a5.923 5.923 0 0 0 8.033-8.033l1.237-1.236zm-1.834-2A7.615 7.615 0 0 0 4.936 13.024l1.211-1.211a5.923 5.923 0 0 1 8.25-8.25l1.211-1.211z"
	    }
	  })])])])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app",
	      "flex": "dir:top"
	    }
	  }, [_c('router-view', {
	    attrs: {
	      "user": _vm.user
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "protocol-content"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v("Affiliate Program "), _c('br'), _vm._v(" Terms and Conditions")]), _vm._v(" "), _c('div', {
	    staticClass: "prompt"
	  }, [_c('p', {
	    staticClass: "font"
	  }, [_vm._v("\n      Thank you for your interest in partnering with VIPKid! The VIPKid Affiliate Program\n      (\"Affiliate Program\") gives you the opportunity to perform Referral Services\n      (as defined below) to refer qualified teacher candidates to teach with VIPKid.\n      Before you submit your application on behalf of yourself or an entity, organization,\n      or company, please read these terms and conditions (\"Terms and Conditions\") carefully.\n      If you are applying on behalf of an entity, organization, or company, by checking the\n      box marked \"I Agree\", you represent and warrant: (1) that you have the authority to\n      bind it to the Terms and Conditions (as set forth below in the Section entitled,\n      \"Warranties\"); (2) that you agree to all the Terms and Conditions on behalf of\n      yourself, as well as the entity, organization, or company; and (3) that you will\n      comply with the relevant provisions set forth below if accepted into the Affiliate\n      Program. For the purpose of the Terms and Conditions, “you” shall mean (1) yourself; or\n      (2) the entity, organization, or company you represent, and yourself, the representative\n      of same.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "font",
	    staticStyle: {
	      "margin-top": "20px"
	    }
	  }, [_vm._v("\n      If you provide any information that is untrue, inaccurate, not current or incomplete,\n      if VIPKid has reasonable grounds to suspect that any information you provide is untrue,\n      inaccurate, not current or incomplete, and/or if you violate any provision in the Terms\n      and Conditions, VIPKid may block your current or future application(s) for the Affiliate\n      Program. After reviewing your application, VIPKid may contact you for any additional\n      documentation or information, at its sole discretion.\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "partner"
	  }, [_c('p', {
	    staticClass: "subtitle more-spacing"
	  }, [_vm._v("Affiliate Partner Eligibility")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      To apply for this Affiliate Program, you do not need to be a current teacher and/or\n      have an independent contractor agreement with VIPKid. The Affiliate Program is open\n      to individual and institutional applicants, so you may apply on behalf of yourself\n      or any entity, organization, or company you represent.\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "refer-teachers"
	  }, [_c('p', {
	    staticClass: "subtitle more-spacing"
	  }, [_vm._v("How to Refer New Teachers")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      If your application is approved, you will receive an affiliate link and become an\n      Affiliate Partner. You will only receive one affiliate link. Use of multiple affiliate\n      links may result in your removal from this Affiliate Program. You may perform referral\n      services (including, but not limited to, creating original works, blogs, or advertisements\n      in compliance with the Terms and Conditions, or driving traffic to the VIPKid website for\n      individuals to sign up to teach on the platform) to obtain Referrals (“Referral Services”).\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Referrals must use your affiliate link before completing the basic info stage. VIPKid cannot\n      add and/or change "), _c('br'), _vm._v("     the affiliate link used after that point.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("VIPKid reserves the right to limit the use of your affiliate link, and/or establish additional\n      rules around how, when, "), _c('br'), _vm._v("     and where such affiliate link may be shared.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "incentive"
	  }, [_c('p', {
	    staticClass: "subtitle more-spacing"
	  }, [_vm._v("How to Earn Affiliate Incentives")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      To earn your Affiliate Incentive as an Affiliate Partner, your Referral must: (1) not have previously signed up to be a\n      teacher or taught on the VIPKid platform; (2) meet all the conditions VIPKid has for signing up to become a teacher;\n      (3) use your affiliate link before completing the basic info stage; and (4) take any other actions required by VIPKid\n      to become a teacher. VIPKid reserves the right to deny your Referral access to the VIPKid platform in its sole discretion.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      Referrals can only be referred once, so if someone else has referred them and they have accepted that invitation, they\n      will not be able to accept yours.\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "general-rules"
	  }, [_c('p', {
	    staticClass: "subtitle more-spacing"
	  }, [_vm._v("General Rules")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("By accepting, sharing, or using an affiliate link, you are agreeing to be bound by the Terms\n        and Conditions, as well "), _c('br'), _vm._v("     as all applicable laws and regulations.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Affiliate Partners may not contact VIPKid for status updates regarding their Referrals.\n        The requirements for "), _c('br'), _vm._v("     receiving, and the amounts of, Affiliate Incentives are subject\n        to change at VIPKid’s sole discretion without "), _c('br'), _vm._v("     notice.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("VIPKid reserves the right to change, end, or pause, in whole or in part, the Terms and Conditions.\n        VIPKid also "), _c('br'), _vm._v("     reserves the right to interpret these Terms and Conditions in its sole\n        discretion.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("VIPKid may, in its sole discretion, update, or modify these Terms and Conditions at any time without\n        prior notice. "), _c('br'), _vm._v("     All updates will be posted in the Referral Query System (RQS)\n        and shall apply immediately to all Referrals who "), _c('br'), _vm._v("     use an affiliate link as of the day that\n        the updates are posted. Continued participation in this Affiliate Program "), _c('br'), _vm._v("     after any update\n        means that you have consented to the update.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Violation of the Terms and Conditions may result in: (1) you not being eligible to participate in this\n        Affiliate "), _c('br'), _vm._v("     Program and/or future affiliate programs; (2) forfeiture of any Affiliate Incentives\n        earned through this Affiliate "), _c('br'), _vm._v("     Program; (3) deactivation of your affiliate link; and/or (4) any\n        other action permitted by law or contract.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Participation in this Affiliate Program is prohibited where void by applicable law or regulation.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "affiliate-incentives"
	  }, [_c('p', {
	    staticClass: "subtitle more-spacing"
	  }, [_vm._v("Affiliate Incentives")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("As an Affiliate Partner, you are eligible to earn Affiliate Incentives according to the chart below.\n        The Affiliate "), _c('br'), _vm._v("     Incentive paid will be based upon the Terms and Conditions in effect at the time\n        that the Referral signs an "), _c('br'), _vm._v("     independent contractor agreement with VIPKid.")])]), _vm._v(" "), _c('div', {
	    staticClass: "table-box"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', {
	    staticClass: "header"
	  }, [_c('th', {
	    staticClass: "first"
	  }, [_vm._v("Number of successful referrals per calendar month (Beijing Time)")]), _vm._v(" "), _c('th', [_vm._v("1")]), _vm._v(" "), _c('th', [_vm._v("2")]), _vm._v(" "), _c('th', [_vm._v("3-6")]), _vm._v(" "), _c('th', [_vm._v("7-10 ")]), _vm._v(" "), _c('th', [_vm._v("11-20")]), _vm._v(" "), _c('th', [_vm._v("21+")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
	    staticClass: "body"
	  }, [_c('td', {
	    staticClass: "first"
	  }, [_vm._v("Payment (per successful referral)")]), _vm._v(" "), _c('td', [_vm._v("USD 50")]), _vm._v(" "), _c('td', [_vm._v("USD 65")]), _vm._v(" "), _c('td', [_vm._v("USD 80")]), _vm._v(" "), _c('td', [_vm._v("USD 100")]), _vm._v(" "), _c('td', [_vm._v("USD 120")]), _vm._v(" "), _c('td', [_vm._v("USD 130")])])])])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("A Referral Incentive is deemed earned after the Referral signs an independent contractor agreement with\n        VIPKid. "), _c('br'), _vm._v("     Payment will only be made for Referral Incentives earned during the time you are\n        participating in the Affiliate "), _c('br'), _vm._v("     Program, except VIPKid will pay an Affiliate Partner for all\n        Affiliate Incentives earned thirty (30) days following to "), _c('br'), _vm._v("     the\n        termination of the parties’ relationship as set forth below in Section 1 of the General Terms. ")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Affiliate Incentives are paid on a monthly basis. VIPKid will calculate the Affiliate Partner’s total\n        number of "), _c('br'), _vm._v("     Referrals per calendar month and an email will be sent to the Affiliate Partner for\n        confirmation at the beginning "), _c('br'), _vm._v("     of the following calendar month. Any Affiliate Incentives that\n        is not confirmed by the Affiliate Partner after 180 "), _c('br'), _vm._v("     days will expire.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("If you believe that there is a discrepancy regarding your Affiliate Incentives, please contact\n        "), _c('br'), _vm._v("     "), _c('a', {
	    attrs: {
	      "href": "mailto:affiliate@vipkid-intl.com"
	    }
	  }, [_vm._v("affiliate@vipkid-intl.com.")]), _vm._v(" VIPKid may require\n        you to submit additional information in order to make a "), _c('br'), _vm._v("     determination regarding your balance.\n        All decisions regarding your balance will be final and at VIPKid’s sole "), _c('br'), _vm._v("     discretion.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("VIPKid reserves the right to suspend your affiliate link, remove or limit your ability to participate\n        in this Affiliate "), _c('br'), _vm._v("     Program, and/or withhold Affiliate Incentives, if VIPKid suspects any activity\n        is abusive, fraudulent, or in violation "), _c('br'), _vm._v("     of the Terms and Conditions or applicable law, or any\n        fraud, technical failures, or other factor beyond VIPKid's "), _c('br'), _vm._v("     reasonable control impairs the\n        integrity or proper functioning of this Affiliate Program, as determined by VIPKid "), _c('br'), _vm._v("     in its sole\n        discretion.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "incentive"
	  }, [_c('p', {
	    staticClass: "subtitle more-spacing"
	  }, [_vm._v("Prohibited Use")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      1. Affiliate links may be used for commercial or promotional purposes. However, you agree to not solicit, spam, or mass\n      email anyone with your affiliate link.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      2. You may not obtain Referrals by using any unethical and/or improper means, including, but not limited to, the following:\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font",
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Duplicating, selling, or transferring your affiliate link in any manner;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Using paid advertisements to distribute your affiliate link to the general public (i.e. Google,\n        Facebook, Instagram, "), _c('br'), _vm._v("     Twitter, Bing, Craigslist, LinkedIn, or job posting websites)\n        while presenting yourself as a representative of "), _c('br'), _vm._v("     VIPKid;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Creating or distributing any job posts, paid or unpaid, on any job posting websites (i.e.\n        LinkedIn, Google, "), _c('br'), _vm._v("     Facebook, Instagram, Twitter, Bing, Craigslist);")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Paying or providing anything of value to any potential Referrals while presenting yourself\n        as a representative of "), _c('br'), _vm._v("     VIPKid, or promising to do so;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Purchasing Referrals from other teachers or Affiliate Partners, or requesting that other\n        teachers or Affiliate "), _c('br'), _vm._v("     Partners use your affiliate link in exchange for some\n        sort of benefits or payment;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Using, displaying, altering, or manipulating VIPKid’s Intellectual Property (as defined\n        below), as well as the "), _c('br'), _vm._v("     intellectual property of its parents, subsidiaries,\n        affiliates, and related entities, in any way;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Creating or registering any: (1) businesses; (2) URLs; (3) domain names; (4) software\n        application names or titles "), _c('br'), _vm._v("     that include the word \"VIPKid\" or any of VIPKid’s\n        other trademarks or any words that are confusingly similar to "), _c('br'), _vm._v("     VIPKid’s trademarks,\n        or contain permutations of VIPKid;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Purchasing keywords (including, but not limited to, Google, Bing, or other search\n        engines or digital channels) that "), _c('br'), _vm._v("     contain any of VIPKid’s trademarks;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Using automated systems or bots through any channel to distribute, post, or otherwise\n        share your affiliate link;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Slandering, defaming, and/or speaking negatively about other teachers in an effort\n        to persuade Referrals to use "), _c('br'), _vm._v("     your affiliate link;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Using scripts or programmed or automatic dialers to send invites or otherwise share\n        your affiliate link;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Making misleading claims about VIPKid, using offensive/abusive content, creating\n        fake "), _c('br'), _vm._v("     websites/webpages/social media profiles/apps, or otherwise making any\n        false or misleading statements to get "), _c('br'), _vm._v("     Referrals to use your affiliate\n        link;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Misrepresenting yourself as a representative or employee of VIPKid to third parties,\n        such as at job fairs, on "), _c('br'), _vm._v("     LinkedIn or job websites, or on personally created\n        websites or social media platforms;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Using your affiliate link in any manner that violates the law or the rights of anyone\n        else;")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Requesting contact information or personal information from your Referrals, and engaging\n        in phishing or "), _c('br'), _vm._v("     attempting to obtain financial or other personal information\n        or solicit passwords or personally identifiable "), _c('br'), _vm._v("     information from your\n        Referrals; and/or")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font"
	  }, [_vm._v("\n      • "), _c('span', {
	    staticClass: "left-spacing"
	  }, [_vm._v("Creating fake accounts/false identities and use said accounts/identities, to sign up\n        and use your affiliate links.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      3. VIPKid reserves the right, in its sole discretion, to take action against any person it finds to be tampering\n      with the operation of this Affiliate Program or to be acting in violation of the Terms and Conditions, or otherwise.\n      Any attempt by any person to deliberately undermine the legitimate operation of this Affiliate Program may be a\n      violation of criminal and civil law, and, should such an attempt be made, VIPKid reserves the right to seek damages\n      from any such person to the fullest extent permitted by law.\n    ")])]), _vm._v(" "), _c('div', {
	    staticClass: "refer-teachers"
	  }, [_c('p', {
	    staticClass: "subtitle more-spacing"
	  }, [_vm._v("General Terms")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      1. Term and Termination: The Terms and Conditions shall take effect immediately after you check the box marked \"I Agree\"\n      (the \"Effective Date\"), and shall continue until the earliest of the following: (1) sixty [60] days from the Effective\n      Date, if not formally accepted into the Affiliate Program; (2) rejection from the Affiliate Program; (3) expiration of\n      the Initial Term (as defined below) or, if participation in the Affiliate Program is renewed, upon expiration of the\n      Renewal Term (as defined below); (4) until your participation in this Affiliate Program is terminated upon written\n      notice of one of the parties; or (5) if superseded by another agreement with VIPKid.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font",
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_vm._v("\n      The \"Initial Term\" is defined as the (6) months beginning on the day that you receive written notice from VIPKid that\n      you were accepted into the Affiliate Program. After the Initial Term, you may elect to renew the Terms and Conditions\n      for additional terms of six (6) months beginning the day after your prior Term expires and ending six (6) months\n      thereafter (the \"Renewal Term\"). To enter into a Renewal Term, five (5) business days prior to the expiration of your\n      current Term, you must contact "), _c('a', {
	    attrs: {
	      "href": "mailto:affiliate@vipkid-intl.com"
	    }
	  }, [_vm._v("affiliate@vipkid-intl.com,")]), _vm._v(" in writing,\n      to notify VIPKid of your intent to renew the Terms and Conditions and enter into a Renewal Term, and VIPKid may accept\n      this request at its sole discretion.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      2. Non-Disparagement: If accepted into the Affiliate Program, you agree that you will not make, directly or indirectly,\n      to any person or entity, including, but not limited to, VIPKid’s present, future, and/or former employees or clients,\n      and/or the press, any negative or disparaging oral or written statements about VIPKid or your relationship with VIPKid,\n      or do anything which damages VIPKid or any of its services, reputation, good will, financial status, or business or\n      client relationships, whether by electronic, written, or oral means. Nothing in this Section shall preclude you from\n      testifying honestly if required by law to testify. \n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      3. Warranties: If accepted into the Affiliate Program, you represent, warrant, and covenant that: (i) the Referral\n      Services you perform will be performed in a professional and workmanlike manner and that none of such Referral\n      Services nor any part of the Terms and Conditions is or will be inconsistent with any obligation you may have to\n      others; (ii) all Referral Services provided under the Terms and Conditions shall be your original work and none of\n      the Referral Services will infringe, misappropriate or violate any intellectual property or other right of any\n      person or entity (including, but not limited to, your own); (iii) you shall comply with all applicable laws when\n      providing Referral Services; and (iv) if your Referral Services require a license, you have obtained that license\n      and the license is in full force and effect.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      4. Intellectual Property: You understand that VIPKid owns or is licensed to use all Intellectual Property rights\n      (as defined below) therein throughout the globe. Intellectual Property includes, without limitation, all trademarks,\n      service marks, inventions, works of authorship, designs, know-how, ideas and information, software (including object\n      code and source code), design, text, photographs, images, illustrations, audio, video, artwork, graphic material,\n      or other copyrightable elements, and the selection and arrangements thereof, trademarks, service marks, trade names,\n      trade dress, look and feel, patents, patentable material, and causes of action related thereto, including VIPKid\n      curriculum and related materials, and recordings of classes arranged through the VIPKid Platform, and lesson notes\n      uploaded to the teacher portal. VIPKid is entitled to take any possible legal action to get remedy against your\n      infringement of the above Intellectual Property in the globe by itself or together with its licensor.The Terms and\n      Conditions do not grant you any rights in VIPKid’s Intellectual Property.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font",
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_vm._v("\n      To the extent any of the foregoing is ineffective under applicable law, you hereby provide any and all ratifications\n      and consents necessary to accomplish the purposes of the foregoing to the extent possible. You will confirm any such\n      ratifications and consents from time to time as requested by VIPKid.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      5. Independent Contractor Relationship: The parties understand and agree that the Terms and Conditions create the\n      relationship of principal and independent contractor, not employer and employee. The Terms and Conditions are not\n      intended to create, and shall not create, an employment relationship, a joint venture, partnership, or similar\n      relationship, for any purpose, including, but not limited to, the Federal Insurance Contributions Act, the Social\n      Security Act, the Federal Unemployment Tax Act, income tax withholding requirements, and all other federal, state\n      and local laws, rules and regulations. By accepting the Terms and Conditions, you represent and acknowledge that\n      you are not entitled to workers’ compensation benefits provided by VIPKid, or unemployment benefits following\n      termination of the parties’ relationship, and you are required to pay all federal, state, and local income taxes\n      on any monies earned pursuant to the Affiliate Program.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      6. Tools and Equipment: You shall be responsible for providing, solely at your expense, all equipment, tools, and\n      supplies needed to perform Referral Services under the Terms and Conditions. You shall be solely responsible for\n      all costs and expenses of doing business, including all wages and other compensation for any employees, agents, or\n      subcontractors you engage or hire, and all taxes and other business expenses that may be incurred in connection\n      with your performance of Referral Services under the Terms and Conditions. \n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      7. Indemnification and Insurance:  You agree to indemnify, protect and hold harmless VIPKid from any and all claims,\n      demands, damage, suits, losses, liabilities and causes of action arising directly or indirectly from, as a result\n      of or in connection with, the actions of you or your personnel arising from the performance of Referral Services\n      under the Terms and Conditions, including personal injury or death to any person, including you or your personnel.\n      Your obligations hereunder shall include VIPKid’s cost of defense as well as the payment of any final judgment\n      rendered against VIPKid.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      You acknowledge and agree that VIPKid shall not obtain insurance coverage of any kind, including workers'\n      compensation insurance, on behalf of you or your personnel. During the term of the Terms and Conditions,\n      you agree to maintain insurance that will insure against any and all liabilities, losses, damages, injuries,\n      or expenses that may arise from or result from the actions or omissions of you or your personnel. Such insurance\n      shall include, but not be limited to, such workers' compensation or occupational accident insurance (where permitted\n      by law), general liability insurance, and other insurance necessary or appropriate to cover loss or damaged property\n      and injury or death to persons in connection with the services furnished by you or your personnel.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      8. Arbitration: In the event of a dispute between the parties, the parties agree to resolve the dispute as described\n      in this Arbitration Provision. This Arbitration Provision is governed by the Federal Arbitration Act\n      (9 U.S.C. § 1, et seq.) and evidences a transaction involving commerce. The parties expressly agree that this\n      Arbitration Provision shall be governed by the Federal Arbitration Act even in the event you and/or VIPKid are\n      otherwise exempted from the Federal Arbitration Act. Any disputes in this regard shall be resolved exclusively by an\n      Arbitrator. In the event, but only in the event, the Arbitrator or a court determines the Federal Arbitration Act does\n      not apply, the state law governing arbitration agreements in the state in which you perform the majority of services\n      covered by the Terms and Conditions shall apply. This Arbitration Provision applies to any past, existing or future\n      claim, regardless of the date of its accrual, brought by either you or VIPKid, arising out of or related to the Terms\n      and Conditions, your relationship with VIPKid, your participation in the Affiliate Program, including without limitation,\n      your classification as an independent contractor or termination of the relationship with VIPKid, and your provision of\n      Referral Services under the Terms and Conditions, whether arising under federal, state, or local law. The terms of this\n      Arbitration Provision will remain in force after the parties’ contractual relationship ends. Except as it otherwise\n      provides, this Arbitration Provision is intended to apply to the resolution of disputes that otherwise would be resolved\n      in a court of law or before any forum other than arbitration. "), _c('span', {
	    staticClass: "bold"
	  }, [_vm._v("THIS ARBITRATION PROVISION REQUIRES ALL\n      SUCH DISPUTES TO BE RESOLVED ONLY BY AN ARBITRATOR THROUGH FINAL AND BINDING ARBITRATION ON AN INDIVIDUAL BASIS, AND NOT\n      BY WAY OF COURT OR JURY TRIAL, OR BY WAY OF CLASS, COLLECTIVE, OR REPRESENTATIVE ACTION.")])]), _vm._v(" "), _c('p', {
	    staticClass: "describe font",
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_vm._v("\n      Each party will pay the fees for its own attorneys, subject to any remedies to which that party may later be entitled under\n      applicable law. Costs incidental to the arbitration, including the cost of the Arbitrator and the meeting site\n      (\"Arbitration Costs\"), will be borne by VIPKID and you equally, unless otherwise required by applicable law. Any dispute\n      regarding a party’s obligation to pay Arbitration Costs will be determined by the Arbitrator. In the event you contend that,\n      as a matter of law, you are not responsible for payment of any or part of your portion of the Arbitration Costs, you will\n      have no obligation to pay that portion of the contested Arbitration Costs until, and only if, the Arbitrator determines\n      that you are responsible for those costs. If necessary for arbitration of the dispute, VIPKid agrees to cover the amount of\n      the Arbitration Costs contested by you until such time as the Arbitrator determines payment responsibility. If the Arbitrator\n      determines that you are responsible for any amount of the Arbitration Costs already paid by VIPKid, you will remit payment of\n      that amount to VIPKid within thirty (30) days of the Arbitrator’s determination, and if the Arbitrator determines that VIPKid\n      is responsible for any amount of the Arbitration Costs already paid by you, VIPKid will remit payment of that amount to you\n      within thirty (30) days of the Arbitrator’s determination.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font",
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_vm._v("\n      You have the right to consult with private counsel of your choice with respect to any aspect of, or any claim that may be subject\n      to, this Arbitration Provision. In the event any portion of this Arbitration Provision is deemed unenforceable, the remainder of\n      this Arbitration Provision will be enforceable.\n    ")]), _vm._v(" "), _c('p', {
	    staticClass: "describe font few-spacing"
	  }, [_vm._v("\n      9. Entire Agreement, Modification, and Survival: The Terms and Conditions constitute the entire agreement and understanding between\n      the parties with respect to the Referral Services. VIPKid may modify, alter, change, or amend the Terms and Conditions in its\n      sole discretion. The Non-Disparagement, Indemnification and Insurance, and Arbitration Provisions shall survive termination of\n      the Terms and Conditions.\n    ")])])])
	}]}

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "protocol-wrapper"
	  }, [_c('protocol-header'), _vm._v(" "), _c('protocol-content')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "information",
	    attrs: {
	      "flex": "dir:top",
	      "flex-box": "1"
	    }
	  }, [_vm._m(0), (!_vm.success) ? _c('div', {
	    staticClass: "form-box",
	    attrs: {
	      "flex-box": "1"
	    }
	  }, [_c('section', [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("Essential information")]), _c('div', {
	    staticClass: "input-box",
	    attrs: {
	      "flex": "dir:left main:justify cross:center"
	    }
	  }, [_c('div', {
	    staticClass: "side-box",
	    attrs: {
	      "flex-box": "0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.firstName.value),
	      expression: "from.firstName.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.firstName.isActive) && !_vm.from.firstName.isTrue
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "First Name"
	    },
	    domProps: {
	      "value": (_vm.from.firstName.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.firstName)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.firstName, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.firstName.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("nameFilter")(_vm.from.firstName.value, _vm.from.firstName)))])]), _c('div', {
	    staticClass: "side-box",
	    attrs: {
	      "flex-box": "0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.lastName.value),
	      expression: "from.lastName.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.lastName.isActive) && !_vm.from.lastName.isTrue
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Last Name"
	    },
	    domProps: {
	      "value": (_vm.from.lastName.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.lastName)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.lastName, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.lastName.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("nameFilter")(_vm.from.lastName.value, _vm.from.lastName)))])])]), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.contactEmail.value),
	      expression: "from.contactEmail.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.contactEmail.isActive) && !_vm.from.contactEmail.isTrue
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Contact Email"
	    },
	    domProps: {
	      "value": (_vm.from.contactEmail.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.contactEmail)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.contactEmail, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.contactEmail.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("emailFilter")(_vm.from.contactEmail.value, _vm.from.contactEmail)))])]), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.phoneNumber.value),
	      expression: "from.phoneNumber.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.phoneNumber.isActive) && !_vm.from.phoneNumber.isTrue
	    },
	    attrs: {
	      "type": "number",
	      "placeholder": "Phone Number",
	      "oninput": "if(value.length>16)value=value.slice(0,16)"
	    },
	    domProps: {
	      "value": (_vm.from.phoneNumber.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.phoneNumber)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.phoneNumber, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.phoneNumber.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("numFilter")(_vm.from.phoneNumber.value, _vm.from.phoneNumber)))])]), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.companyName.value),
	      expression: "from.companyName.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.companyName.isActive) && !_vm.from.companyName.isTrue
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Company Name"
	    },
	    domProps: {
	      "value": (_vm.from.companyName.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.companyName)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.companyName, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.companyName.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("charactersFilter")(_vm.from.companyName.value, _vm.from.companyName)))])]), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.companyWebsite.value),
	      expression: "from.companyWebsite.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.companyWebsite.isActive) && !_vm.from.companyWebsite.isTrue
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Company Website / Blog Site / Online presence"
	    },
	    domProps: {
	      "value": (_vm.from.companyWebsite.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.companyWebsite)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.companyWebsite, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.companyWebsite.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.companyWebsite.value, _vm.from.companyWebsite)))])]), _c('div', {
	    staticClass: "input-box"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.companyType.value),
	      expression: "from.companyType.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.companyType.isActive) && !_vm.from.companyType.isTrue
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.companyType)
	      },
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.from.companyType, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Company type")]), _c('option', {
	    attrs: {
	      "value": "Recruiting company"
	    }
	  }, [_vm._v("Recruiting company")]), _c('option', {
	    attrs: {
	      "value": "ESL teaching program"
	    }
	  }, [_vm._v("ESL teaching program")]), _c('option', {
	    attrs: {
	      "value": "Blogger"
	    }
	  }, [_vm._v("Blogger")]), _c('option', {
	    attrs: {
	      "value": "Marketing agency"
	    }
	  }, [_vm._v("Marketing agency")]), _c('option', {
	    attrs: {
	      "value": "School staff"
	    }
	  }, [_vm._v("School staff")]), _c('option', {
	    attrs: {
	      "value": "Others"
	    }
	  }, [_vm._v("Others")])]), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.companyType.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.companyType.value, _vm.from.companyType)))])]), _c('div', {
	    staticClass: "input-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.potentialTeacherNumber.value),
	      expression: "from.potentialTeacherNumber.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.potentialTeacherNumber.isActive) && !_vm.from.potentialTeacherNumber.isTrue
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Number of potential teachers in your network"
	    },
	    domProps: {
	      "value": (_vm.from.potentialTeacherNumber.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.potentialTeacherNumber)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.potentialTeacherNumber, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.potentialTeacherNumber.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.potentialTeacherNumber.value, _vm.from.potentialTeacherNumber)))])]), _c('div', {
	    staticClass: "input-box"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.businessDescription.value),
	      expression: "from.businessDescription.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.businessDescription.isActive) && !_vm.from.businessDescription.isTrue
	    },
	    attrs: {
	      "placeholder": "Description of your business"
	    },
	    domProps: {
	      "value": (_vm.from.businessDescription.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.businessDescription)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.businessDescription, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.businessDescription.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.businessDescription.value, _vm.from.businessDescription)))])]), _c('div', {
	    staticClass: "input-box"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.channels.value),
	      expression: "from.channels.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.channels.isActive) && !_vm.from.channels.isTrue
	    },
	    attrs: {
	      "placeholder": "Through what channels will you market to potential teachers"
	    },
	    domProps: {
	      "value": (_vm.from.channels.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.channels)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.channels, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.channels.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.channels.value, _vm.from.channels)))])]), _c('div', {
	    staticClass: "input-box verification-box",
	    attrs: {
	      "flex": "dir:left"
	    }
	  }, [_c('div', {
	    staticClass: "side-box verify-code-input",
	    attrs: {
	      "flex-box": "0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.imageCode.value),
	      expression: "from.imageCode.value"
	    }],
	    class: {
	      'error_input': (_vm.showError || _vm.from.imageCode.isActive) && !_vm.from.imageCode.isTrue
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Verification code"
	    },
	    domProps: {
	      "value": (_vm.from.imageCode.value)
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.changeActive(_vm.from.imageCode)
	      },
	      "focus": _vm.focusImageCode,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.from.imageCode, "value", $event.target.value)
	      }
	    }
	  }), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.imageCode.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("imageCodeFilter")(_vm.from.imageCode.value, _vm.from.imageCode)))])]), _c('div', {
	    staticClass: "side-box verify-code-img",
	    attrs: {
	      "flex-box": "0"
	    }
	  }, [_c('img', {
	    attrs: {
	      "alt": "verification code",
	      "src": _vm.imageCodeImgSrc
	    },
	    on: {
	      "click": function($event) {
	        return _vm.getVerifyCode()
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "label-box auto"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.from.isAgree.value),
	      expression: "from.isAgree.value"
	    }],
	    attrs: {
	      "name": "is-agree",
	      "type": "checkbox",
	      "id": "all-agree",
	      "value": "value"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.from.isAgree.value) ? _vm._i(_vm.from.isAgree.value, "value") > -1 : (_vm.from.isAgree.value)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.from.isAgree.value,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "value",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.from.isAgree, "value", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.from.isAgree, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.from.isAgree, "value", $$c)
	        }
	      }
	    }
	  }), _vm._m(1), _c('p', {
	    staticClass: "error",
	    class: {
	      'show-error': _vm.showError || _vm.from.isAgree.isActive
	    }
	  }, [_vm._v(_vm._s(_vm._f("agreeFilter")(_vm.from.isAgree.value, _vm.from.isAgree)))])]), _c('div', {
	    staticClass: "btn-box",
	    attrs: {
	      "flex": "dir:left"
	    }
	  }, [_c('div', {
	    staticClass: "btn",
	    attrs: {
	      "flex-box": "0"
	    },
	    on: {
	      "click": _vm.validateFrom
	    }
	  }, [_vm._v("Apply")])])])]) : _c('div', {
	    staticClass: "success-box",
	    attrs: {
	      "flex-box": "1"
	    }
	  }, [_vm._m(2)]), _c('div', {
	    staticClass: "tp-footer",
	    attrs: {
	      "flex-box": "0"
	    }
	  }, [_vm._v("© VIPKID Beijing ICP 14002500")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "top-banner",
	    attrs: {
	      "flex": "dir:left main:justify cross:center",
	      "flex-box": "0"
	    }
	  }, [_c('a', {
	    staticClass: "logo",
	    attrs: {
	      "href": "https://www.vipkid.com/mkt/affiliate-program",
	      "flex-box": "0"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(281)
	    }
	  })]), _c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "/login",
	      "flex-box": "0"
	    }
	  }, [_vm._v("Sign In")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    attrs: {
	      "for": "all-agree"
	    }
	  }, [_vm._v("By entering my own name/company name below, l warrant that l have read and understand\nfully the content and meaning of the "), _c('a', {
	    staticClass: "import",
	    attrs: {
	      "href": "/protocol",
	      "target": "_blank"
	    }
	  }, [_vm._v("Referral Service Agreement")]), _vm._v(" and l am willing to enter into this agreement and agreed all terms of the agreement,\nincluding but not limited to arbitration clause and class action waiver, and no action\nwill be taken by or on behalf of the undersigned with respect to any such terms.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "success-bg",
	    attrs: {
	      "flex": "cross:center main:center"
	    }
	  }, [_c('div', {
	    staticClass: "tips",
	    attrs: {
	      "flex": "dir:left cross:top main:center"
	    }
	  }, [_c('div', {
	    staticClass: "logo"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(282)
	    }
	  })]), _c('div', {
	    staticClass: "msg"
	  }, [_c('h2', [_vm._v("Your information has been submitted.")]), _c('p', [_vm._v("Thank you for your interest in becoming our affiliate partner! Our team\nwill review your application and get back to you via email in 5 business days.")]), _c('a', {
	    attrs: {
	      "href": "https://www.vipkid.com/mkt/affiliate-program",
	      "target": "_blank"
	    }
	  }, [_vm._v("Learn more about the affiliate program >")])])])])
	}]}

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-wrapper"
	  }, [_c('div', {
	    staticClass: "logo"
	  }), _c('div', {
	    staticClass: "login-bg"
	  }, [_c('div', {
	    staticClass: "form-title"
	  }, [_vm._v("Referrals Query System")]), _c('form', {
	    staticClass: "login-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    staticClass: "username login-input",
	    class: {
	      active: _vm.usernameErrorShow
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Username"
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.username = $event.target.value
	      }
	    }
	  }), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "password login-input",
	    class: {
	      active: _vm.passwordErrorShow
	    },
	    attrs: {
	      "type": "password",
	      "Placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.verificationShow),
	      expression: "verificationShow"
	    }],
	    staticClass: "verification"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.imageCode),
	      expression: "imageCode"
	    }],
	    ref: "code",
	    staticClass: "verification login-input",
	    class: {
	      active: _vm.verificationErrorShow
	    },
	    attrs: {
	      "type": "text",
	      "Placeholder": "Verification code",
	      "maxlength": "4"
	    },
	    domProps: {
	      "value": (_vm.imageCode)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.imageCode = $event.target.value
	      }
	    }
	  }), _c('img', {
	    staticClass: "verification-img",
	    attrs: {
	      "src": _vm.verifycodeSrc
	    },
	    on: {
	      "click": _vm.getVerifyCode
	    }
	  })]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.signErrorShow),
	      expression: "signErrorShow"
	    }],
	    staticClass: "error-msg"
	  }, [_vm._v(_vm._s(_vm.signErrorMsg))]), _c('button', {
	    staticClass: "login-btn",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.sign($event)
	      }
	    }
	  }, [_vm._v("Sign In")]), _vm._m(0)])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.expired),
	      expression: "expired"
	    }],
	    staticClass: "expired-container"
	  }, [_c('div', {
	    staticClass: "alert-area"
	  }, [_c('div', {
	    staticClass: "close-btn"
	  }), _c('img', {
	    staticClass: "oops",
	    attrs: {
	      "src": __webpack_require__(283)
	    }
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v("Your contract has " + _vm._s(_vm.status) + ", so you are unable to login.")]), _vm._m(1), _c('div', {
	    staticClass: "ok-btn",
	    on: {
	      "click": _vm.closeExpiredDialog
	    }
	  }, [_vm._v("OK")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-tip"
	  }, [_vm._v("If you need help, please contact us via email: "), _c('a', {
	    attrs: {
	      "href": "mailto:affiliate@vipkid-intl.com"
	    }
	  }, [_vm._v("affiliate@vipkid-intl.com")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-tips"
	  }, [_vm._v("If you believe this is an error or if you would like to renew your contract, please contact "), _c('a', {
	    attrs: {
	      "href": "mailto:affiliate@vipkid-intl.com"
	    }
	  }, [_vm._v("affiliate@vipkid-intl.com.")])])
	}]}

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page",
	    attrs: {
	      "id": "referral-page"
	    }
	  }, [_c('navbar', {
	    attrs: {
	      "user": _vm.user
	    }
	  }), _c('el-popover', {
	    ref: "contractdata",
	    attrs: {
	      "placement": "bottom",
	      "width": "320",
	      "trigger": "manual"
	    },
	    model: {
	      value: (_vm.isShowContractDataPopover),
	      callback: function($$v) {
	        _vm.isShowContractDataPopover = $$v
	      },
	      expression: "isShowContractDataPopover"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "font-size": "18px",
	      "line-height": "2em"
	    }
	  }, [_vm._v("Your contract will expire in " + _vm._s(_vm.user.expiresDay) + ".")]), _c('p', {
	    staticStyle: {
	      "font-size": "14px"
	    }
	  }, [_vm._v("If you would like to renew it, please contact  "), _c('a', {
	    attrs: {
	      "href": "mailto:affiliate@vipkid-intl.com"
	    }
	  }, [_vm._v("affiliate@vipkid-intl.com")])]), _c('el-button', {
	    staticStyle: {
	      "width": "8em",
	      "margin": "1em"
	    },
	    on: {
	      "click": _vm.closeContractDataPopover
	    }
	  }, [_vm._v("OK")])], 1)]), _c('div', {
	    staticClass: "page-title"
	  }, [_vm._v("Referrals Query"), _c('span', {
	    staticClass: "contract-info"
	  }, [_c('b', [_vm._v("Contract Date")]), (_vm.user.expires) ? _c('span', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:contractdata",
	      arg: "contractdata"
	    }],
	    ref: "infoicon",
	    staticClass: "el-icon-information",
	    staticStyle: {
	      "margin": "3px",
	      "cursor": "pointer",
	      "color": "#73ba00"
	    },
	    on: {
	      "click": _vm.toggleContractDataPopover
	    }
	  }) : _vm._e(), _vm._v("  " + _vm._s(_vm.user.contractStartTime) + " - " + _vm._s(_vm.user.contractEndTime))])]), _c('hr'), _c('div', {
	    staticClass: "the-query-bar"
	  }, [_c('query-bar', {
	    on: {
	      "querychanged": _vm.queryChanged
	    }
	  })], 1), _c('div', {
	    staticClass: "data-list"
	  }, [_c('span', {
	    staticStyle: {
	      "line-height": "2em"
	    }
	  }, [_vm._v("Total Records: " + _vm._s(_vm.total))]), _c('el-table', {
	    class: {
	      empty: _vm.total === 0, loading: _vm.loading
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "empty-text": _vm.tableStatusText,
	      "show-header": _vm.tableData.length > 0
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name"
	    }
	  }), _c('el-table-column', {
	    attrs: {
	      "prop": "username",
	      "label": "Email"
	    }
	  }), _c('el-table-column', {
	    attrs: {
	      "prop": "mobile2",
	      "label": "Mobile Phone"
	    }
	  }), _c('el-table-column', {
	    attrs: {
	      "prop": "applyDate",
	      "label": "Apply Date"
	    }
	  }), _c('el-table-column', {
	    attrs: {
	      "prop": "lifeCycle",
	      "label": "Life Cycle"
	    }
	  }), _c('el-table-column', {
	    attrs: {
	      "prop": "status",
	      "label": "Status"
	    }
	  }), _c('el-table-column', {
	    attrs: {
	      "prop": "result",
	      "label": "Result"
	    }
	  }), _c('el-table-column', {
	    attrs: {
	      "prop": "regularDate",
	      "label": "Become regular teacher"
	    }
	  }), _c('el-table-column', {
	    attrs: {
	      "prop": "scheduledDateTime",
	      "label": "Teach 1st class"
	    }
	  })], 1), (_vm.total > _vm.pageSize) ? _c('el-pagination', {
	    attrs: {
	      "layout": "prev,pager,next",
	      "current-page": _vm.currentPage,
	      "page-size": _vm.pageSize,
	      "total": _vm.total
	    },
	    on: {
	      "current-change": _vm.onCurrentPageChange
	    }
	  }) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// js/app.eae67a045e8e956c11ab.js